import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="relative flex min-h-[80vh] items-center justify-center overflow-hidden bg-[#F3F7FB] pt-20">
      <div className="absolute inset-0 blueprint-grid" aria-hidden="true" />
      <div className="relative text-center">
        <p className="accent-text font-display text-7xl font-extrabold uppercase sm:text-8xl">404</p>
        <p className="mt-4 text-slate-500">This track doesn't lead anywhere.</p>
        <Link to="/" className="btn btn-primary mt-8" data-testid="notfound-home-link">
          Back to Home
        </Link>
      </div>
    </section>
  );
}
